<template>
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
            <v-card-text>Are you sure you want to remove this rule ?</v-card-text>
            <v-divider></v-divider>
            <v-card-text>{{ akpr.akpr_regel }}</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="warning mx-2" small @click="rmAkpr">Yes</v-btn>
                <v-btn color="success"  small @click="dialog = false">No</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() { 
            return {
                dialog: false,
                akpr: {
                    akpr_regel: ""
                }
            }
        },
        methods: {
            openDialog(akpr) {
                this.akpr = akpr
                this.dialog = true;
            },
            rmAkpr() { 
                this.$axios.post("ares/json/ares/syst/ref/akcd/rmAkprv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "rmAkprv2"
                    },
                    rmAkprv2: {
                        akpr_encrid: this.akpr.akpr_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else { 
                        // this.$router.reload('/syst/ref/akcd/searchAkcd/'); 
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.rmAkprv2.text,
                            color: res.data.rmAkprv2.color
                        });
                        this.$emit("deletedAkpr", this.akpr.akpr_encrid)
                        this.dialog = false;
                    }
                })
            },
        }   
    }
</script>

